export default __webpack_public_path__ + "static/media/97_desktop.71d3827e.jpg";